import { STARTER_MONTHLY_PRICE_INR } from './billing/plans';

export type LitigantPricingVariant = 'litigant_199';

export type LitigantPricingOffer = {
  variant: LitigantPricingVariant;
  monthlyPriceInr: 199;
  checkoutPlanId: 'starter_monthly';
};

export const DEFAULT_LITIGANT_PRICING_OFFER: LitigantPricingOffer = {
  variant: 'litigant_199',
  monthlyPriceInr: STARTER_MONTHLY_PRICE_INR,
  checkoutPlanId: 'starter_monthly',
};

export const LITIGANT_PRICING_OFFERS: Record<LitigantPricingVariant, LitigantPricingOffer> = {
  litigant_199: DEFAULT_LITIGANT_PRICING_OFFER,
};

export function assignLitigantPricingOffer(): LitigantPricingOffer {
  return DEFAULT_LITIGANT_PRICING_OFFER;
}

export function normalizeLitigantPricingVariant(value: unknown): LitigantPricingVariant | null {
  return value === 'litigant_199' ? value : null;
}

export function litigantOfferFromProfile(
  profile: {
    litigant_pricing_variant?: string | null;
    litigant_price_monthly_inr?: number | null;
  } | null | undefined,
): LitigantPricingOffer {
  const variant = normalizeLitigantPricingVariant(profile?.litigant_pricing_variant);
  if (variant) return LITIGANT_PRICING_OFFERS[variant];

  if (profile?.litigant_price_monthly_inr === STARTER_MONTHLY_PRICE_INR) {
    return LITIGANT_PRICING_OFFERS.litigant_199;
  }

  return DEFAULT_LITIGANT_PRICING_OFFER;
}

export function litigantCheckoutHref(): string {
  const params = new URLSearchParams({
    tier: 'starter',
    billing: 'monthly',
    checkout: '1',
    source_surface: 'litigant_lite_demo',
  });

  return `/pricing?${params.toString()}`;
}
